<template>
  <div class="resource_body">
    <div>
      <el-row style="margin: 0px">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
          <div class="grid-content bg-purple"></div>
          <el-row :gutter="10">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
              <div class="grid-content bg-purple"></div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  style="
                    width: 210px;
                    background-color: white;
                    height: 200px;
                    border-radius: 15px;
                    padding-top: 10px;
                  "
                >
                  <el-menu
                    :default-active="activeIndex"
                    class="el-menu-vertical-demo"
                    @select="handleOpen"
                  >
                    <el-menu-item index="1">
                      <i class="el-icon-s-platform"></i>
                      <span slot="title">仪器设备</span>
                    </el-menu-item>
                    <el-menu-item index="2">
                      <i class="el-icon-stopwatch"></i>
                      <span slot="title">网络要求</span>
                    </el-menu-item>
                    <el-menu-item index="3">
                      <i class="el-icon-set-up"></i>
                      <span slot="title">技术架构</span>
                    </el-menu-item>
                  </el-menu>
                </div>
              </div>
            </el-col>
            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
              <div class="grid-content bg-purple-light"></div>
              <div style="display: flex; align-items: center">
                <div class="content_text_body">
                  <div v-if="this.activeIndex === '1'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        仪器设备
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div style="width: 900px"></div>
                      <div class="resource_right">
                        操作系统：Windows<br />
                        CPU：双核以上<br />
                        内存：4G及其以上<br />
                        显存：512M以上<br />
                        磁盘：500G及其以上<br />
                        分辨率：1366*768以上
                      </div>
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '2'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        网络要求
                      </div>
                    </div>
                    <div class="content_text_m">
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          width: 1000px;
                        "
                      >
                        <img
                          src="../../assets/network01.jpg"
                          style="width: 95%; margin: 20px auto"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="this.activeIndex === '3'">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 10px;
                        border-bottom: 2px solid #0e64d9;
                        height: 60px;
                      "
                    >
                      <div
                        style="
                          font-size: 25px;
                          color: #0e64d9;
                          text-align: left;
                          line-height: 50px;
                          padding-left: 20px;
                        "
                      >
                        技术架构
                      </div>
                    </div>
                    <div class="content_text_m">
                      <img
                        src="../../assets/technology_3.jpg"
                        style="width: 100%; padding: 20px"
                      />
                      <!--  <div style="width: 1000px">
                        <img
                          src="../../assets/technology.png"
                          style="width: 100%"
                        />
                        <div class="knowledge_text">
                          产纤维素酶菌株筛选与酶基因克隆分析虚拟仿真教学系统的开放运行依托于开放式虚拟仿真实验教学管理平台的支撑，二者通过数据接口无缝对接,保证用户能够随时随地的通过浏览器访问该项目，并通过平台提供的面向用户的
                          智能指导、自动批改服务功能，尽可能帮助用户实现自主的实验。加强实验项目的开放服务能力，提升开放服务效果。
                        </div>
                        <div class="knowledge_text">
                          开放式虚拟仿真实验教学管理平台以计算机仿真技术、多媒体技术和网络技术为依托，采用面向服务的软件架构开发，集实物仿真、创新设计、智能指导、虚拟实验结果自动批改和教学管理于—体，是具有良好自主性、交互性和可扩展性的虚拟实验教学平台。
                        </div>
                        <div class="knowledge_text">
                          如架构图所示，支撑项目运行的平台及项目运行的架构共分为五层，每一层都为其上层提供服务，直到完成具体虚拟实验教学环境的构建。下面将按照从下至上的顺序分别阐述各层的具体功能。
                        </div>
                        <div class="knowledge_text">
                          1．数据层<br />
                          产纤维素酶菌株筛选与酶基因克隆分析虚拟仿真教学系统涉及到多种类型虚拟实验组件及数据，这里分别设置虚拟实验的基础元件库、实验课程库典型实验库、标准答案库、规则库、实验数据、用户信息等来实现对相应数据的存放和管理。
                        </div>
                        <div class="knowledge_text">
                          2.支撑层<br />
                          支撑层是虚拟仿真实验教学与开放共享平台的的核心框架，是实验项目正常开放运行的基础，负责整个基础系统的运行、维护和管理。支撑平台包括以下几个功能子系统:安全管理、服务容器、数据管理、资源管理与监控、域管理、域间信息服务等。
                        </div>
                        <div class="knowledge_text">
                          3．通用服务层<br />
                          通用服务层即开放式虚拟仿真实验教学管理平台，提供虚拟实验教学环境的一些通用支持组件，以便用户能够快速在虚拟实验环境完成虚拟仿真实验。通用服务包括:实验教务管理、实验教学管理、理论知识学习、实验资源管理、互动交流、实验报告管理、教学效果评测、项目开放共享等，同时提供相应集成接口工具，以便该平台能够方便集成第三方的虚拟实验软件进入统一管理。
                        </div>
                        <div class="knowledge_text">
                          4．仿真层<br />
                          仿真层主要针对该项目进行相应的器材建模、实验场景构建、虚拟仪器开发、提供通用的仿真器，最后为上层提供实验结果数据的格式化输出。
                        </div>
                        <div class="knowledge_text">
                          5．应用层<br />
                          基于底层的服务，最终产纤维素酶菌株筛选与酶基因克隆分析虚拟仿真教学系统与开放共享。该框架的应用层具有良好的扩展性，实验教师可根据教学需要，利用服务层提供的各种工具和仿真层提供的相应的器材模型，设计各种典型实验实例，最后面向学校开展实验教学应用。
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Resource",
  data () {
    return {
      activeIndex: "1",
      buttonType1: "",
      buttonType2: "",
      buttonType3: "",
      buttonType4: "",
      buttonIndex: "",
    };
  },
  mounted () {
    this.cutpage("1");
    let num = localStorage.getItem("redirectNum");
    if (num !== "undefined") {
      this.activeIndex = num;
    } else {
      this.activeIndex = "1";
    }
  },
  methods: {
    cutpage (index) {
      this.buttonIndex = index;
      this.getbottontype();
    },
    getbottontype () {
      if (this.buttonIndex === "1") {
        this.buttonType1 = "primary";
        this.buttonType2 = "";
        this.buttonType3 = "";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "2") {
        this.buttonType1 = "";
        this.buttonType2 = "primary";
        this.buttonType3 = "";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "3") {
        this.buttonType1 = "";
        this.buttonType2 = "";
        this.buttonType3 = "primary";
        this.buttonType4 = "";
      } else if (this.buttonIndex === "4") {
        this.buttonType1 = "";
        this.buttonType2 = "";
        this.buttonType3 = "";
        this.buttonType4 = "primary";
      }
    },
    handleOpen (key, keyPath) {
      this.activeIndex = key;
    },
  },
};
</script>

<style scoped>
.resource_body {
  background: url('../../assets/banner/login.png');
}

.content_text_body {
  display: flex;
  background-color: white;
  height: auto;
  min-height: 625px;
  margin-bottom: 40px;
  border-radius: 15px;
  flex-direction: column;
  width: 100%;
}

.content_text_m {
}

.resource_right {
  width: 100%;
  font-size: 20px;
  text-align: center;
  line-height: 50px;
  padding-top: 50px;
  font-weight: 400;
}
.knowledge_text {
  text-indent: 2em;
  font-size: 18px;
  margin: 5px 20px 0 20px;
  text-align: left;
  line-height: 30px;
  font-weight: 300;
  line-height: 40px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>